import React, { useEffect, useRef, useState } from "react";
import { Divider, Grid, Typography } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import InputField from "../../customComponent/InputField";
import { MainContainer } from "../../content/content.element";
import { InfoHeader } from "../../customComponent/InfoHeader";
import { SubmitButton } from "../../customComponent/Buttons";

import { findUniversityAction } from "../../../actions/universityActions/universityManagmentAction";
import { createFeaturedAdsAction, featuredAdsEditAction, findFeaturedAdsByIdAction } from "../../../actions/LandingPageAction";
import Swal from "sweetalert2";
import { successTrueMsgAction } from "../../../actions/globalAction";
import { useParams } from "react-router-dom";

function EditFeaturedAds(props) {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [DestinationimageValue, setDestinationimageValue] = useState("");
  const [content, setContent] = useState("");
  const [name, setName] = useState("");
  const [newsImage, setNewsImage] = useState();
  const [addIframe, setIframe] = useState("");
  const [iframeError, setIframeError] = useState(false);
  const [error, setError] = useState('');


  const newsimage = useRef();

  let { successAlertMsgSuccess } = useSelector((state) => {
    return state.successTrueMsg;
  });

  let { featuredAdsFindByIdSuccess } = useSelector((state) => {
    return state.findFeaturedAdsById;
  });

  useEffect(() => {
    dispatch(findFeaturedAdsByIdAction(id));
  }, [id]);

  useEffect(() => {
    if (featuredAdsFindByIdSuccess) {
      console.log(featuredAdsFindByIdSuccess, "featuredAdsFindByIdSuccess");
      let data = featuredAdsFindByIdSuccess;
      setIframe(data?.mp4);
      setDestinationimageValue(data?.imageUrl);
      setName(data?.name);
      setContent(data?.content);
    }
  }, [featuredAdsFindByIdSuccess]);


  useEffect(() => {
    if (successAlertMsgSuccess) {
      Swal.fire("Updated", "Featured Ads Edited Successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
  }, [successAlertMsgSuccess]);

  const handleDestinationImage = (event) => {
    const file = event.target.files[0];
    setDestinationimageValue(file.name);
    const reader = new FileReader();

    // Read the image file as a data URL
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const UploadDestinationimage = reader.result;
      setNewsImage(UploadDestinationimage);
    };
  };

  // handleinput

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const containsIframe = /<iframe.*?<\/iframe>/i.test(inputValue);

    if (containsIframe) {
      setIframe(e.target.value);
      setIframeError(false);
    } else {
      setIframeError(true);
    }
  };

  const validate = () => {
    let errorList = {};
    if (!name) {
      errorList.name = "Please provide an Ad Name";
    }
    if (!addIframe) {
      errorList.addIframe = "Please provide iFrame link from source document";
    }
    if (!content) {
      errorList.content = "Please Input the content here";
    }
    if (!newsImage) {
      errorList.newsImage = "Please upload an image";
    }
    setError(errorList);
    return Object.keys(errorList).length === 0;
  };

  // HandleCreate
  const HandleCreate = () => {
    if (validate()) {
      dispatch(featuredAdsEditAction(id, newsImage, name, addIframe, content));
      dispatch(successTrueMsgAction(true));
    }
  };

  return (
    <MainContainer active={props.toggle}>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          backgroundColor: "white",
        }}
      >
        <InfoHeader headTitle="Edit Featured Ads" url={"/landingPage"} />
      </div>
      <Divider />

      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12} md={6} lg={4} style={{ position: "relative" }}>
          <Grid>
            <InputField
              label="Logo"
              widthSize="92%"
              value={DestinationimageValue}
              required
              paramses
              readonly={true}
            ></InputField>
          </Grid>
          <Grid style={{ position: "absolute", top: 5, right: 30 }}>
            <button
              onClick={() => newsimage.current.click()}
              style={{
                width: "100px",
                height: "40px",
                fontSize: "13px",
                fontFamily: "monospace",
                border: "none",
              }}
            >
              Browse
            </button>
            <input
              ref={newsimage}
              type="file"
              accept="image/*"
              onChange={(event) => handleDestinationImage(event)}
              style={{ display: "none" }}
            ></input>
          </Grid>
          {Boolean(error.newsImage) && (
            <Typography
              sx={{
                fontSize: "12px",
                color: "red",
                mt: "-15px"
              }}
            >
              {error.newsImage}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={6} lg={4} style={{ position: "relative" }}>
          <InputField
            label="Name"
            widthSize="92%"
            value={name}
            handleChange={(e) => setName(e.target.value)}
            required
            paramses
            error={Boolean(error.name)}
            helperText={error.name}
          ></InputField>
        </Grid>

        <Grid item xs={12} md={6} lg={4} style={{ position: "relative" }}>
          <InputField
            label="Media"
            handleChange={handleChange}
            widthSize="100%"
            value={addIframe}
            InputType="discription"
            error={Boolean(error.addIframe)}
            helperText={error.addIframe}
          />
          {iframeError ? (
            <Typography
              sx={{ fontSize: "12px", fontWeight: 400, color: "red" }}
            >
              It is not an Iframe link, Please provide an Iframe link
            </Typography>
          ) : null}
        </Grid>

        <Grid item xs={12} lg={12} sx={{ mt: 3 }}>
          <InputField
            label="Content"
            handleChange={(e) => setContent(e.target.value)}
            widthSize="99.2%"
            value={content}
            InputType="discription"
            // dispcriptionHeight=""
            required
            paramses
            error={Boolean(error.content)}
            helperText={error.content}
          />
        </Grid>
      </Grid>
      {/* Submit Button */}
      <Grid
        item
        xs={4}
        lg={12}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginTop: "10px",
        }}
      >
        <SubmitButton
          title="Save"
          submit=""
          widthSize="100px"
          heightSize="38px"
          type="click"
          handleSubmit={HandleCreate}
        />
      </Grid>
    </MainContainer>
  );
}

export default EditFeaturedAds;
